import decode from 'jwt-decode';

// Backend returns signed JWTs for GraphQL results. Conventions:
//   success -> a JWT whose payload is not { action: 'failure' } (usually has a `data` object)
//   failure -> a JWT whose payload is { action: 'failure', ... }
//   no auth -> a bare string such as "No token detected!" (NOT a JWT) -> decode() throws
// A network reject is handled by the caller's try/catch, not here.
export const decodeJwtResult = (raw) => {
  if (typeof raw !== 'string' || raw.length === 0) {
    return { ok: false, authExpired: false, decoded: null };
  }
  let decoded;
  try {
    decoded = decode(raw);
  } catch (e) {
    // Not a JWT — backend returned a bare string (e.g. "No token detected!") = expired/missing session.
    return { ok: false, authExpired: true, decoded: null };
  }
  if (!decoded || decoded.action === 'failure') {
    return { ok: false, authExpired: false, decoded };
  }
  return { ok: true, authExpired: false, decoded };
};

// Maps a thrown error / failed save into a user-facing message + auth flag.
// authExpired when the caller tagged it, or when jwt-decode threw an InvalidTokenError.
export const classifySaveError = (err) => {
  const authExpired = !!err && (err.name === 'InvalidTokenError' || err.authExpired === true);
  return {
    authExpired,
    message: authExpired
      ? 'Your session has expired. Please log in again to finish setting up your profile.'
      : 'Sorry, something went wrong saving your progress. Please try again.',
  };
};
